const compactDisplayName = value => {
  const parts = String(value || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length < 3) return parts.join(" ");

  const first = parts[0];
  const last = parts[parts.length - 1];
  const middleInitials = parts
    .slice(1, -1)
    .map(part => `${part.charAt(0).toUpperCase()}.`)
    .join(" ");

  return `${first} ${middleInitials} ${last}`.replace(/\s+/g, " ").trim();
};

const nameSearchHaystack = value => {
  const full = String(value || "")
    .trim()
    .toLowerCase();
  const compact = compactDisplayName(value).toLowerCase();
  return `${full} ${compact}`;
};

const nameMatchesQuery = (value, query) => {
  const needle = String(query || "")
    .trim()
    .toLowerCase();
  if (!needle) return true;
  return nameSearchHaystack(value).includes(needle);
};

module.exports = {
  compactDisplayName,
  nameMatchesQuery,
  nameSearchHaystack
};
